import Odometer from 'odometer';
import anime from 'animejs';
import {} from 'jquery-mousewheel';

let aboutHistory = () => {

  let module = {},
    canAnimate = true,
    odometerElement,

    createInterestingFactsPopup = (item) => {
      var fact = item.find('.history-interesting-fact');

      if (!fact.length) {
        return;
      }

      // console.log();

      var body = $('html,body');
      var text = item.find('.history-interesting-fact-text').html();
      var src = item.find('.history-item-image').data('popup-image');
      var year = (item.data('history-item-year') + '').slice(2, 4);
      var popup = $('.history-interesting-fact-popup');
      var popupText = popup.find('.history-interesting-fact-popup-text');
      popup.find('.history-interesting-fact-popup-image').attr('src', src);
      popupText.attr('data-history-interesting-fact-popup-year', "‘" + year);
      popupText.html(text);

      popup.find('.citem-text').css('opacity', '1');

      body.addClass('overflow-hidden');
      popup.css('display', 'block');

      window.setTimeout(function() {
        popup.addClass('active');
      }, 50);
    },

    attachButtonInterestingFactClick = () => {
      $('.history-item-interesting-fact-mobile>button').on('click', function () {
        var $this = $(this);
        var historyItem = $this.closest('.history-item');
        createInterestingFactsPopup(historyItem);
      });
    },

    attachReadMoreTagClick = () => {
      $('.read-more-tag').on('click', function () {
        createInterestingFactsPopup($('.history-item.active'));
      });
    },

    attachButtonInterestingFactCloseClick = () => {
      $('.history-interesting-fact-popup-close').on('click', function () {
        var popup = $('.history-interesting-fact-popup');
        var body = $('html, body');
        body.removeClass('overflow-hidden');

        popup.removeClass('active');
        window.setTimeout(function() {
          popup.css('display', 'none');
        }, 250);
      });
    },

    activateTimelinePoint = (year) => {
      var allYears = $('[data-timeline-year]');
      allYears.removeClass('active');
      var activeYear = $('[data-timeline-year="' + year + '"]');
      if (activeYear.length) {
        activeYear.addClass('active');
        $('[data-timeline-progress-year]').attr('data-timeline-progress-year', year);
      }
    },

    activateTimelineItem = (element, doAnimate) => {
      if (! canAnimate) {
        return;
      }
      canAnimate = false;

      let elementYear = element.attr('data-history-item-year');
      let previousElement= $('.history-item.active');

      let deltaY = 1000; // how much pixels do we move

      let elementStartY = deltaY;
      let previousElementEndY = -1 * deltaY;
      let delay = 0;

      $('html').addClass('overflow-hidden');

      if ($(window).width() < 768) {
        $('html,body').animate({ scrollTop: 0 }, 'slow');
        delay = 750;
      }

      odometerElement.odometer.update('1' + elementYear.slice(2,4));

      if (previousElement.length != 0) {
        let previousElementYear = previousElement.attr('data-history-item-year');

        // are we going back > or front
        if (previousElementYear > elementYear) {
          elementStartY = -1 * deltaY;
          previousElementEndY = deltaY;
        }

        anime({
          targets: previousElement.get(0),
          translateY: [0, previousElementEndY],
          opacity: 0,
          duration: 1500,
          easing: 'easeInOutExpo',
          delay: delay,
          begin: function() {
            previousElement.css('display', 'flex');
            previousElement.removeClass('active');
          },
          complete: function() {
            previousElement.css('display', 'none');
          }
        });
      }

      anime({
        targets: element.get(0),
        translateY: [elementStartY, 0],
        opacity: 1,
        duration: 1500,
        delay: delay,
        easing: 'easeInOutExpo',
        begin: function() {
          element.css('display', 'flex');
          element.addClass('active');
        },
        complete: function() {
          $('html').removeClass('overflow-hidden');
        }
      });

      activateTimelinePoint(elementYear);

      // $('#historySelect').selectpicker('val', elementYear);

      window.setTimeout(function() {
        canAnimate = true;
      }, 2000);
    },

    attachPaginationClickEvent = () => {
      $('[data-pagination-year], [data-timeline-year]').on('click', function (event) {

        var $this = $(this);
        var year = $this.attr('data-pagination-year');
        if (!year) {
          year = $this.attr('data-timeline-year');
        }

        var item = $('[data-history-item-year="' + year + '"]');

        if (item.length) {
          activateTimelineItem(item);
        }

      });
    },

    attachSelectEvent = () => {
      $('#historySelect').change(function() {
        let year = $(this).find('option:selected').first().val();
        activateTimelineItem($('[data-history-item-year="' + year + '"]'));
      });
    },

    initActiveItems = () => {
      var firstItem = $('.history-item:first-child');
      if (firstItem.length !== 1) {
        return;
      }

      activateTimelineItem(firstItem);
    },

    attachWheelEvent = () => {

      $('.history-item').on('mousewheel', function (event) {

        var prev = $(this).prev('.history-item');
        var next = $(this).next('.history-item');

        if (canAnimate) {
          if (event.deltaY == 1 && prev.length) {
            activateTimelineItem(prev);
          } else if (event.deltaY == -1 && next.length) {
            activateTimelineItem(next);
          }
        }


      });
    },

    initOdometer = () => {
      odometerElement = document.querySelector('.history-item-year');

      new Odometer({
        el: odometerElement,
        value: 110,
        duration: 2000,
      });
    },

    init = () => {
      if (!$('.history-item').length) {
        return;
      }

      initOdometer();
      initActiveItems();
      attachPaginationClickEvent();
      attachButtonInterestingFactClick();
      attachButtonInterestingFactCloseClick();
      attachReadMoreTagClick();
      attachSelectEvent();
      attachWheelEvent();
    };

  module.init = init;

  return module;

};

export default aboutHistory();